// Mock data for Embassy Verde 2.0 website

export const projectInfo = {
  name: "Embassy Verde 2.0",
  tagline: "1, 2, 2.5 & 3 BHK Apartments",
  location: "Embassy Springs Devanahalli Bangalore",
  priceStarting: "61 Lakhs*",
  phone: "+919066840485",
  whatsappMessage: "Please share the details for embassy Verde 2.0",
  reraId: "PRM/KA/RERA/1250/303/PR/101224/007284"
};

export const overview = [
  { icon: "MapPin", label: "Location", value: "Embassy Springs, Devanahalli" },
  { icon: "Maximize", label: "Township", value: "Part of 280 Acres" },
  { icon: "Building2", label: "No. of Units", value: "700 Units*" },
  { icon: "Building", label: "No. of Towers", value: "3 Towers*" },
  { icon: "Layers", label: "No. of Floors", value: "G + 18 Floors" },
  { icon: "BedDouble", label: "Unit Variants", value: "1, 2, 2.5 & 3 BHK" },
  { icon: "HardHat", label: "Status", value: "New Launch" },
  { icon: "FileCheck", label: "RERA ID", value: "PRM/KA/RERA/1250/..." }
];

export const highlights = [
  "Part of 280-acre Embassy Springs Township in Devanahalli, off Airport Road, North Bangalore",
  "Mixed-use development offering villas, plots, apartments, senior living, clubhouse, school, office spaces & healthcare",
  "Designed to offer Luxury, Convenience and Comfort",
  "Elegantly Designed Homes with Premium Finishes",
  "Stunning Views from your Balcony",
  "Bedrooms thoughtfully designed for Singles, Young Couples and Small Families"
];

export const gallery = [
  { src: "https://embassyverde.com/images/banner.jpg", alt: "Embassy Verde Elevation" },
  { src: "https://embassyverde.com/images/Mask-Group-8.png", alt: "Embassy Verde Facade" },
  { src: "https://embassyverde.com/images/Mask-Group-7.png", alt: "Living Room" },
  { src: "https://embassyverde.com/images/Mask-Group-4.png", alt: "Master Bedroom" },
  { src: "https://embassyverde.com/images/Mask-Group-14.png", alt: "Balcony View" },
  { src: "https://embassyverde.com/images/Mask-Group-12.png", alt: "Embassy Springs" }
];

export const priceList = [
  { type: "1 BHK", size: "601 - 663 Sq. Ft.", price: "61 - 71 Lakhs*" },
  { type: "2 BHK", size: "946 - 948 Sq. Ft.", price: "91 - 98 Lakhs*" },
  { type: "2.5 BHK", size: "1108 Sq. Ft.", price: "1.05 - 1.13 Cr*" },
  { type: "3 BHK", size: "1274 - 1344 Sq. Ft.", price: "1.21 - 1.37 Cr*" }
];

export const amenities = [
  { name: "Arrival Plaza", icon: "DoorOpen" },
  { name: "Swimming Pool", icon: "Waves" },
  { name: "Sports Courts", icon: "Trophy" },
  { name: "Scenic Driveways", icon: "Car" },
  { name: "Pet Park", icon: "Dog" },
  { name: "Curated Clubhouse", icon: "Home" },
  { name: "Community Spaces", icon: "Users" },
  { name: "Serene Walkways", icon: "Footprints" },
  { name: "Kids Play Area", icon: "Baby" },
  { name: "Gymnasium", icon: "Dumbbell" },
  { name: "Landscaped Gardens", icon: "TreePine" },
  { name: "24/7 Security", icon: "Shield" }
];

export const locationAdvantages = [
  { place: "Shell Technology Center", distance: "4 km" },
  { place: "Kempegowda International Airport", distance: "12 km" },
  { place: "Thanisandra", distance: "18 km" },
  { place: "Yelahanka", distance: "17 km" },
  { place: "Hennur", distance: "18 km" },
  { place: "Budigere Cross", distance: "20 km" },
  { place: "Manyata Tech Park", distance: "20 km" }
];

export const floorPlans = [
  { name: "1 BHK Floor Plan", image: "https://embassyverde.com/images/Mask-Group-7.png" },
  { name: "2 BHK Floor Plan", image: "https://embassyverde.com/images/Mask-Group-4.png" },
  { name: "Master Plan", image: "https://embassyverde.com/images/map-verde.jpg" }
];

export const aboutEmbassy = {
  title: "About Embassy Group",
  description: "Founded in 1993, Embassy Group is one of India's largest real estate conglomerates with a broad portfolio of over 66 million sq. ft. of prime commercial, residential, retail, hospitality, services, and educational spaces across Delhi NCR, Bangalore, Chennai, Pune, Mumbai, Noida and Trivandrum in the Indian market and Serbia and Malaysia in the international market. Across all asset classes, Embassy places a strong emphasis on high standards of quality, delivery, world-class services, environmental management, and safety. Embassy sponsored India's first publicly traded REIT and Asia's largest REIT by area."
};
